export const firstChar = /(?:^|\s)\S/g;
